/**
 * Specifies all the dashboard widgets
 */
import { PERMISSIONS } from '@amp/auth';

export enum DashboardWidgetEnum {
  DevicesHealth = 'DevicesHealth',
  ContentStatistics = 'ContentStatistics',
  DevicesErrors = 'DevicesErrors',
  DevicesWarning = 'DevicesWarning',
  DevicesSuccess = 'DevicesSuccess',
  DevicesUnreachable = 'DevicesUnreachable',
  DevicesNotMonitored = 'DevicesNotMonitored',
  UpTime = 'UpTime',
  ServerOverview = 'ServerOverview',
  MonitoringSpeed = 'MonitoringSpeed',
  BandwidthUsage = 'BandwidthUsage',
  CpuUsage = 'CpuUsage',
  MemUsage = 'MemUsage',
  DiskUsage = 'DiskUsage',
  SystemLoad = 'SystemLoad',
  ProcessDetails = 'ProcessDetails',
}

/**
 * Specifies all the dashboard widgets permissions
 */
export const DashboardWidgetsPermissions = new Map<DashboardWidgetEnum, string[]>();
DashboardWidgetsPermissions.set(DashboardWidgetEnum.MonitoringSpeed, [PERMISSIONS.ADMIN_OP]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.BandwidthUsage, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.ContentStatistics, [PERMISSIONS.SETUP_PUBLICATION_RESOURCES]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.CpuUsage, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.DevicesErrors, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.DevicesHealth, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.DevicesSuccess, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.DevicesWarning, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.DevicesUnreachable, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.DevicesNotMonitored, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.DiskUsage, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.MemUsage, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.UpTime, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.ServerOverview, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.SystemLoad, [PERMISSIONS.GET_MONITORING_VIEW]);
DashboardWidgetsPermissions.set(DashboardWidgetEnum.ProcessDetails, [PERMISSIONS.GET_MONITORING_VIEW]);
